module.exports = __webpack_public_path__ + "static/integration/img/material-icons/ic_clear_white_24px.7b66831ce156de757d9bc34d4744da93.svg";